import { useQuery } from '@tanstack/react-query';

import * as api from 'apis/merchant-onboarding-service/api';
import { Merchant } from 'apis/restaurant-api/merchant-admin/merchant/types';

export const useOnboardingStatus = ({ merchants }: { merchants?: Merchant[] }) => {
  const { data: onboardingStatusData, isLoading: isFetchingOnboardingStatus } = useQuery(
    ['merchant-admin/me/onboarding-status'],
    () => api.getOnboardingStatus(),
    {
      enabled: !!merchants,
    },
  );
  return { onboardingStatusData, isFetchingOnboardingStatus };
};
